import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class DeltaPostingService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following deltaPostingServiceFactory pattern exactly
  triggerDeltaPosting(
    baseUrl: string,
    returnClobSettingsObj: any[],
    ecSaveDtls: any[],
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=pl2nzf`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Build clob_settings as an array (required format)
    const settingsObj = returnClobSettingsObj && returnClobSettingsObj.length > 0 ? returnClobSettingsObj[0] : {};
    const clobSettings: any = {
      tax_year: settingsObj?.tax_year || filterParams?.tax_year || globalService?.globalParams?.tax_year || '',
      scenario: parseInt(settingsObj?.scenario || filterParams?.scenario || globalService?.globalParams?.scenario || '74'),
      jcd_key: settingsObj?.jcd_key || filterParams?.jcd_key || globalService?.globalParams?.jcd_key || '',
      sso_id: settingsObj?.sso_id || globalService?.globalParams?.sso_id || '',
      combination_key: parseInt(settingsObj?.combination_key || rowData?.COMBINATION_KEY || '0'),
      tp_key: parseInt(settingsObj?.tp_key || rowData?.TP_KEY || '0'),
      pship_ptr_posting_key: parseInt(settingsObj?.pship_ptr_posting_key || rowData?.PSHIP_PTR_POSTING_KEY || '0')
    };
    
    // Build clob_data from ecSaveDtls (rowData array)
    const clobData = ecSaveDtls || [];
    
    // Build JSON objects exactly like AngularJS service
    // clob_settings must be an array
    const jsonSettings = JSON.stringify([clobSettings]);
    // clob_data must be an array
    const jsonData = JSON.stringify(clobData);
    
    // Extend with clob_data and clob_settings
    params = _.extend({ clob_data: jsonData }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);
    
    // Core parameters from filterParams and globalService
    params.tax_year = filterParams?.tax_year || globalService?.globalParams?.tax_year || rowData?.TAX_YEAR || '';
    params.scenario = filterParams?.scenario || globalService?.globalParams?.scenario || rowData?.SCENARIO || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.globalParams?.jcd_key || rowData?.JCD_KEY || '';
    
    // Additional required fields
    params.issue_id = filterParams?.issue_id || rowData?.ISSUE_ID || '';
    params.issue_short_desc = filterParams?.issue_short_desc || rowData?.ISSUE_SHORT_DESC || '';
    
    // 🚀 CRITICAL: Build checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "combination_key": parseInt(rowData?.COMBINATION_KEY || settingsObj?.combination_key || '0'),
      "scenario_key": parseInt(filterParams?.scenario || globalService?.globalParams?.scenario || rowData?.SCENARIO || '74')
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // Dynamic values from filterParams, globalService, or rowData
    params.scenarioCode = filterParams?.scenarioCode || globalService?.globalParams?.scenarioCode || rowData?.SCENARIO_CODE || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || rowData?.IS_ISSUE_KEY_ENABLED || 'N';

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

